import {
  agent,
  finance,
  greetings,
  utils
} from '@/components/chatbot/actions/index.js'

const state = {
  fullscreen: !1,
  show: !1,
  user: {
    name: 'Você'
  },
  bot: {
    name: 'Assistente Virtual'
  },
  list: [],
  first: !1,
  menu: [
    {
      icon: 'chart-areaspline',
      text: 'Serviços prestados',
      action: 'Em que áreas o escritório de vocês trabalha?'
    },
    {
      icon: 'map-marker',
      text: 'Localização',
      action: 'Qual a sua localização?'
    },
    { icon: 'email', text: 'Contato', action: 'Como posso falar com vocês?' },
    {
      icon: 'av-timer',
      text: 'Horário de Atendimento',
      action: 'Qual o horário de funcionamento de vocês?'
    },
    {
      icon: 'account-group',
      text: 'Principais Clientes',
      action: 'Quais são seus principais clientes?'
    },
    { icon: 'cash', text: 'cotação', action: '10 dólares' }
  ]
}

const actions = {
  show({ commit }, data) {
    commit('SHOW', data)
  },
  setFullscreen({ commit }) {
    commit('SET_FULLSCREEN')
  },
  setShow({ commit }) {
    commit('SET_SHOW')
  },
  setFirst({ commit }) {
    commit('SET_FIRST')
  },
  addList({ commit }, item) {
    commit('ADD', item)
  },
  async action({ dispatch }, { action, func, args = {} }) {
    return await dispatch(action, { func, args })
  },
  async agent({ state }, { func, args }) {
    if (func == 'name') return `Meu nome é <strong>${state.bot.name}</strong>`
    return await agent[func](args)
  },
  greetings({}, { func }) {
    return greetings[func]()
  },
  finance({}, { func, args = {} }) {
    const _func = func.split('.')
    return finance[_func[0]][_func[1]](args)
  },
  utils({}, { func, args = {} }) {
    const _func = func.split('.')
    return utils[_func[0]][_func[1]](args)
  }
}

const mutations = {
  SHOW(state, item) {
    state.show = item
  },
  ADD(state, item) {
    state.list.push(item)
  },
  SET_FULLSCREEN(state) {
    state.fullscreen = !state.fullscreen
  },
  SET_SHOW(state) {
    state.show = !state.show
  },
  SET_FIRST(state) {
    state.first = !0
  }
}

const getters = {
  show: (state) => state.show,
  fullscreen: (state) => state.fullscreen,
  list: (state) => state.list,
  first: (state) => state.first
}

export default {
  namespaced: !0,
  actions,
  mutations,
  getters,
  state
}
